import { createAsyncThunk } from "@reduxjs/toolkit";
import { getAppConfig } from "../../helpers/fakebackend_helper";
import { toast } from 'react-toastify';

export const getAppConfiguration = createAsyncThunk(
  "appSettings/getConfig",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAppConfig();
      
      if (response.data?.data) {
        return {
          data: response.data.data,
          message: response.data.message
        };
      } else {
        throw new Error('Failed to fetch app configuration');
      }
    } catch (error) {
      // Check for token error
      if (error.response?.data === 'Token Not found.' || 
          error.response?.data?.message === 'Token Not found.') {
        // Clear session storage
        sessionStorage.clear();
        // Redirect to login
        window.location.href = '/login';
        return rejectWithValue('Session expired. Please login again.');
      }

      // Show error toast for other errors
      toast.error(error.response?.data?.message || 'Failed to fetch app configuration', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored"
      });

      return rejectWithValue(error.response?.data?.message || 'Failed to fetch app configuration');
    }
  }
); 